class LocalStorageHandler {
    constructor(storageKey) {
        this.storageKey = storageKey;
        this.initStorage();
    }

    initStorage() {
        if (!localStorage.getItem(this.storageKey)) {
            localStorage.setItem(this.storageKey, JSON.stringify({ bundle_for_cart_items: [] }));
        }
    }

    getStorage() {
        return JSON.parse(localStorage.getItem(this.storageKey));
    }

    saveStorage(data) {
        localStorage.setItem(this.storageKey, JSON.stringify(data));
    }

    checkItem(key, value) {
        const storage = this.getStorage();
        const foundItems = storage.bundle_for_cart_items.filter(item => item[key] === value);
        console.log(foundItems);
        return foundItems;
    }

    addItem(item) {
        const storage = this.getStorage();
        storage.bundle_for_cart_items.push(item);
        this.saveStorage(storage);
    }

    removeItem(key, value) {
        let storage = this.getStorage();
        storage.bundle_for_cart_items = storage.bundle_for_cart_items.filter(item => item[key] !== value);
        this.saveStorage(storage);
    }
}


// // Usage example
// const storageHandler = new LocalStorageHandler("cart_data");

// // Add an item
// storageHandler.addItem({ "product_diamond": "1234", "product_setting": "1234" });

// // Check an item
// storageHandler.checkItem("product_diamond", "1234");

// // Remove an item
// storageHandler.removeItem("product_diamond", "1234");
